
import { TabViewModel } from '@/entities/TabViewModel';
import { t } from '@/main';

export class EmailBrandingTabList {
  public TabViewModels: TabViewModel[] = [];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor() {
    this.TabViewModels.push({ Id: 1, ComponentName: 'EmailBranding', Header: t('OrgSettings.EmailBranding').toString() ,IsDisabled: false});
  }
}
